import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../api/client';

/**
 * PageViewTracker (Phase 79) — counts visits to the campaign landing
 * pages (Admin → Campaign Links). One hit per path per browser session
 * per day (sessionStorage debounce). "/" is counted only for anonymous
 * visitors (for logged-in users it's the feed, not the landing).
 */
const TRACKED = ['/', '/creator', '/join-community', '/call', '/cosa-puoi-fare'];

const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (!TRACKED.includes(path)) return;
    if (path === '/' && localStorage.getItem('ig_token')) return;
    const key = `nymia_pv_${path}_${new Date().toISOString().slice(0, 10)}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (_e) { /* storage unavailable — count anyway */ }
    api.post('/telemetry/page-view', { path }).catch(() => {});
  }, [location.pathname]);

  return null;
};

export default PageViewTracker;
